import { Account } from '@/domain/usecases'
import { UserOnboarding } from '@/domain/usecases/onboarding/user-onboarding'
import { QueryClient } from 'react-query'
import OnboardingBaseLoader from './onboarding-base-loader'

export default class OnboardingMainLayoutLoader extends OnboardingBaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient
  ) {
    super(account, queryClient)
  }

  async loader() {
    return this.defer({
      data: super
        .importRemoteModule('makeRemoteUserOnboarding')
        .then(async makeRemoteUserOnboarding => {
          const remoteUserOnboarding = makeRemoteUserOnboarding(this.queryClient) as UserOnboarding
          return remoteUserOnboarding.get()
        })
    })
  }
}
